
import moment from 'moment';

export const applicationTitles = [
    "VERBAL DNA",
    "PRE-DELIVERY",
];

export const checkEditAccess = () => {
    const titleArray = document.title.split(" -", 1);
    let title = titleArray[0];
    if (title) {
        let access = applicationTitles.some((item) => item === document.title);
        return !access;
    }

    return true;
};
export const validateDate = (date, checkMaxDate) => {

    if (checkMaxDate) {
        return moment(date).isBefore(moment(), "day");
    } else {
        const diff = moment(date).diff(moment(), 'milliseconds');
        let duration = moment.duration(diff);
        duration = duration.years() * -1;
        return duration >= 18 && duration <= 100;
    }
}